import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "htmlcontentschemadata"
    }}>{`HtmlContentSchemaData`}</h1>
    <p>{`Represents the proposition response object containing a `}<inlineCode parentName="p">{`html-content`}</inlineCode>{` schema.`}</p>
    <h2 {...{
      "id": "ios-interface"
    }}>{`iOS Interface`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`@objc(AEPHtmlContentSchemaData)
@objcMembers
public class HtmlContentSchemaData: NSObject, Codable {
    /// Represents the content of the HtmlContentSchemaData object.
    public let content: String
    
    /// Determines the value type of \`content\`.  For HtmlContentSchemaData objects, this value is always \`.textHtml\`.
    public let format: ContentType?

    ...
}
`}</code></pre>
    <h2 {...{
      "id": "android-interface"
    }}>{`Android Interface`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public class HtmlContentSchemaData implements SchemaData {
    private String content = null;
    private ContentType format = null;

    @Override
    @Nullable public String getContent() { return content; }

    public ContentType getFormat() { return format; }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      